<ng-container *ngIf="isRouting">
    <div
        class="loader"
        [style.height.px]="height"
        [style.width.px]="width"
        [style.margin]="margin"
        [style.background]="background"
        [style.transform]="rotate"
    >
        <div class="carriage">
            <div class="box"></div>
            <div class="box second"></div>
            <div class="box third"></div>
            <div class="box fourth"></div>
        </div>
    </div>
</ng-container>
<ng-container *ngIf="!isRouting"><ng-content></ng-content></ng-container>
